import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import { Divider } from '@mui/material';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ConfirmDeleteModal({ title, open, setOpen, handleClose, handleChatDelete, deleteUser = false }: { title: string, open: boolean, setOpen?: any, handleClose: any, handleChatDelete: any, deleteUser?: boolean }) {
  return (
    <React.Fragment>
      <Dialog
        classes={{ paper: '!bg-[#191919] !min-w-[350px] !max-w-[550px]' }}
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle classes={{ root: "text-white" }}>{`Delete ${deleteUser ?  "user" : "chat" }?`}</DialogTitle>
        <Divider />
        <DialogContent>
          <DialogContentText classes={{ root: "!text-white" }} id="alert-dialog-slide-description">
            {deleteUser ? 'This will delete your account and all associated information, you will not be able to sign up with the same email address.' : `This will delete ${title}`}.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button sx={{
            backgroundColor: "black",
            color: 'white',
            textTransform: 'none'
          }} onClick={handleClose}>Cancel</Button>
          <Button sx={{
            backgroundColor: "rgba(185,28,28)",
            color: 'white',
            textTransform: 'none'
          }} onClick={handleChatDelete}>Delete</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
